'use strict'

import { loadComponent } from './utils/load-component';
import { getPackage } from '../services/package';
import { getAllDigitalConcerts } from '../services/digital-inventory';

loadComponent('digital-events-list', {
    props: {
        packageNo: {
            type: Number,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                Events: [],
            },
        };
    },

    beforeMount() {
        Promise.all([ getPackage(this.packageNo), getAllDigitalConcerts() ]).then(responses => {
            const [ packageResponse, digitalConcertsResponse ] = responses;

            this.ViewModel.Events = digitalConcertsResponse.filter(event => {
                return packageResponse.Performances.some(details => {
                    return parseInt(details.Id, 10) === parseInt(event.perf_no, 10);
                });
            });
        }).finally(() => {
            this.ViewModel.Loading = false;
        });
    },
});
